/**
 * Development CLOUD: the deployed huddle-sports-development project (demos and
 * shared-state work, NOT the emulator dev loop). `useEmulators: false`, so
 * `src/app/core/firebase.ts` talks straight to the cloud project - the
 * emulator strings stay empty and are never read.
 *
 * Config from the registered huddle-app web app on huddle-sports-development.
 * The emulator-first default lives in `environment.ts`; production in
 * `environment.prod.ts`. All three share one shape so `core/firebase.ts`
 * type-checks against each.
 */
export const environment = {
  production: false,
  useEmulators: false,
  firebase: {
    projectId: 'huddle-sports-development',
    apiKey: 'AIzaSyDop2l1EC8Zb6tg_WbKWAabn1CkFl_qG-Q',
    appId: '1:771300067120:web:6c1f716fe9f9805e5f6af5',
    authDomain: 'huddle-sports-development.firebaseapp.com',
    storageBucket: 'huddle-sports-development.firebasestorage.app',
  },
  emulators: {
    firestore: '',
    auth: '',
    functions: '',
    storage: '',
  },
  region: 'europe-west1',
  /**
   * Where this environment's app lives on the WEB - the address account
   * emails hand a member back to when the app itself is not a web page
   * (`clubContinueUrl`, core/club-slug.ts). The custom domain on the
   * `huddle-sports-development` hosting site (`deploy:development`). Must
   * be on the project's Firebase Auth authorized-domains list or every
   * send is refused with `auth/unauthorized-continue-uri`.
   */
  webOrigin: 'https://development.huddlesports.ie',
  /**
   * The payment provider's PUBLISHABLE key - public by design (it can
   * only start client sessions, never move money). Pairs with the
   * project's STRIPE_SECRET_KEY functions secret: this is the TEST-mode
   * account; switching test accounts means swapping this value and the
   * two functions secrets (see huddle-functions README).
   */
  paymentsPublishableKey:
    'pk_test_51TlWjsGVAyzObsyPwwbR8LrXFYFxdfltnEfw9dtxaLBkRYqaZ3O2T2yLsSJaVSgR4S4TsO3LVM20921LXMkqhhV700H3v4tuBo',
};
